var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-checkbox',{staticClass:"switch-item",attrs:{"disabled":_vm.isDisabled,"switch":""},on:{"change":_vm.SendChange},model:{value:(_vm.mdoelStatus),callback:function ($$v) {_vm.mdoelStatus=$$v},expression:"mdoelStatus"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }